module.exports = __webpack_public_path__ + "img/image40.a2bb7454.png";